import React from "react";
import ProfileInformation from "../../../components/ProfileInformation/ProfileInformation";

const ProfilePage = () => {
   return <ProfileInformation />;
};

export default ProfilePage;
